module.exports = __webpack_public_path__ + "static/media/molly1.46b20761.png";